import { Fragment } from 'react';
import { Grid, Typography } from '@mui/material';

import Form from 'components/Form';
import MuiTable from 'components/MuiTable';
import { IFormRegister } from 'routes/Main/type';

import RowContainer from '../components/RowContainer';
import SectionTitle from '../components/SectionTitle';

interface Props extends IFormRegister {
  disabled?: boolean;
}

const Resurt = (props: Props) => {
  const { disabled, register } = props;

  const columns = [
    { fieldId: 'name', label: '검사종류' },
    { fieldId: 'hbs', label: 'HBs Ag/Ab' },
    { fieldId: 'hiv', label: 'Anti-HIV' },
    { fieldId: 'hcv', label: 'Anti-HCV' },
    { fieldId: 'vdrl', label: 'VDRL' },
    { fieldId: 'rna', label: 'Anti-HCV RNA' },
  ];
  const rows = Array.from({ length: 4 }, (_, i) => {
    const prefix = `test_result.${i}`;
    const kind = [
      '발생당시검사',
      '노출 6주 후 검사',
      '노출 3개월 후 검사',
      '노출 6개월 후 검사',
    ];
    return {
      id: i,
      name: (
        <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>
          {kind[i]}
        </Typography>
      ),
      hbs: (
        <Form.MuiTextField
          required={false}
          disabled={disabled}
          {...register(`${prefix}.hbs`)}
        />
      ),
      hiv: (
        <Form.MuiTextField
          type="number"
          required={false}
          disabled={disabled}
          {...register(`${prefix}.hiv`)}
        />
      ),
      hcv: (
        <Form.MuiTextField
          type="number"
          required={false}
          disabled={disabled}
          {...register(`${prefix}.hcv`)}
        />
      ),
      vdrl: (
        <Form.MuiTextField
          required={false}
          disabled={disabled}
          {...register(`${prefix}.vdrl`)}
        />
      ),
      rna: (
        <Form.MuiTextField
          required={false}
          disabled={disabled}
          {...register(`${prefix}.rna`)}
        />
      ),
    };
  });

  return (
    <Fragment>
      <SectionTitle title="5. 직원의 검사 결과" mb={2} mt={3} />

      <RowContainer xs={12}>
        <Grid item xs={12}>
          <MuiTable columns={columns} rows={rows} />
        </Grid>
      </RowContainer>
    </Fragment>
  );
};

export default Resurt;
